// Step 1 saves through the same updateCase lambda Classic intake uses, so every field is a dotted path
// into the case. Only the structured facts and raw counts persist here; the agent resolves per-plaintiff
// valuation downstream.
export const buildEasyIntakeUpdate = ({ intakeValues }) => ({
  'caseInfo.caseName': intakeValues.caseInfo.caseName,
  'caseInfo.caseType': intakeValues.caseInfo.caseType,
  'caseInfo.stateOfIncident': intakeValues.caseInfo.stateOfIncident,
  'caseInfo.dateOfIncident': intakeValues.caseInfo.dateOfIncident,
  'caseInfo.plaintiffCount': intakeValues.plaintiffCount,
  'caseInfo.defendantCount': intakeValues.defendantCount
});

// The /virtual-user contract from section 7.4 of the build spec. userId and dbName are deliberately
// absent: the PFQ reads both off the JWT, and accepting them from the body would let a client claim
// another tenant. caseRecordIds are absent for the same reason - the PFQ resolves them from caseId.
export const buildVirtualUserPayload = ({ caseId, intakeValues, additionalContext, forceRegenerate = false }) => ({
  caseId,
  caseInfo: {
    caseName: intakeValues.caseInfo.caseName.trim(),
    caseType: intakeValues.caseInfo.caseType,
    stateOfIncident: intakeValues.caseInfo.stateOfIncident,
    dateOfIncident: intakeValues.caseInfo.dateOfIncident,
    additionalContext: (additionalContext ?? '').trim()
  },
  plaintiffCount: intakeValues.plaintiffCount,
  defendantCount: intakeValues.defendantCount,
  // a resubmit over an existing run restarts the assistant and regenerates the letter rather than skipping
  forceRegenerate
});
